import React from 'react'

interface TransparentCardMobileProps {
  title: string
  body: string
  className?: string
}

export const TransparentCardMobile = ({
  title,
  body,
  className,
}: TransparentCardMobileProps) => {
  return (
    <div
      className={`flex min-h-[314px] p-5 flex-col items-start gap-4 self-stretch text-white rounded-xl border border-[#818285] bg-[rgba(0,0,0,0.50)] shadow-[0px_8px_8px_0px_rgba(0,0,0,0.50)] ${className}`}
    >
      <h3 className='text-sm font-medium'>{title}</h3>
      <p
        className='text-xs text-normal text-[#D1D3D7] leading-4 tracking-[0.4px]'
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </div>
  )
}